























































import { RecurrenceIntervention } from "../../../models/RecurrenceIntervention";
import { DateUtils } from "../../../utils/DateUtils";
import EmployeSelect from "../../../core/Forms/EmployeSelect.vue";
import TimeInput from "../../../core/Forms/TimeInput.vue";

export default {
    name: "FrequenceDaysCustomisation",
    components: { TimeInput, EmployeSelect },
    props: {
        recurrenceIntervention: RecurrenceIntervention,
        frequence: RecurrenceIntervention.Frequence,
    },
    data() {
        return {};
    },
    methods: {
        dayName: function (jour: RecurrenceIntervention.FrequenceJour): string {
            return DateUtils.WeekDays[jour.jour].name;
        },
        resetEmployes(jour: RecurrenceIntervention.FrequenceJour) {
            jour.employes = this.recurrenceIntervention.employes;
        },
        resetHeureDebut(jour: RecurrenceIntervention.FrequenceJour) {
            jour.horaire_debut = this.recurrenceIntervention.horaire_debut;
        },
        resetHeureFin(jour: RecurrenceIntervention.FrequenceJour) {
            jour.horaire_fin = this.recurrenceIntervention.horaire_fin;
        },
        // UI
        isSameEmployes(jour: RecurrenceIntervention.FrequenceJour): boolean {
            return _.isEqual(
                jour.employes_ids,
                this.recurrenceIntervention.employes_ids
            );
        },
    },
};
